export const UI_CONSTANTS = {
	PATTERNS: {
		EMAIL: /^[a-zA-Z0-9_\-.]+@[a-zA-Z0-9-]+\.[a-zA-Z\-.]{2,}$/,
		PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*.?-_]{8,}$/,
		PHONE: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
		CURRENCY: /^\d*(\.\d{1,2})?$/,
		EMAIL_OR_PHONE:
			/^([a-zA-Z0-9_\-.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9\-.]+)|((\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4})$/,
		STUDENT_ID: /^[-@./#&+\w\s]*$/,
		CRM_ID: /^[a-zA-Z0-9-]+$/,
		DECIMAL: /^\d+(\.\d{0,2})?$/,
		ALPHANUMERIC: /^[a-zA-Z0-9]+$/,
		ALPHANUMERIC_SPACES: /^(\w+\s)*\w+$/,
		COURSE_NAME: /^[/#&+\w\s&]+$/,
		ALPHABETICAL: /^(\w+-?)*\w+$/,
		ALPHANUMERIC_SPECIAL: /^([a-zA-Z0-9-?–.\/',()&!_:;$*]+\s)*([a-zA-Z0-9-?–.\/',()&!_:;$*])+$/,
		ALPHANUMERIC_SPECIAL_WITH_POUND: /^([a-zA-Z0-9-?–./',()&!_:;$*#]+\s)*([a-zA-Z0-9-?–./',()&!_:;$*#])+$/,
		ALPHANUMERIC_SPECIAL_COMMENT: /^[a-zA-Z0-9-?–./'’,()=+~`|&!_:;$*#@…\s]+$/,
		ALPHANUMERIC_WITH_FEW_SPECIAL_CHARS_ONLY: /^[a-zA-Z0-9.,\-' ]*$/,
		NUMERIC: /^[0-9]*$/,
		LETTERS_ONLY: /^[a-zA-Z ]*$/,
		NUMERIC_ONE_DECIMAL_PLACE: /^(?:\d{0,5}\.\d{1,2})$|^\d{0,5}$/,
		NUMERIC_TWO_DECIMAL_PLACE: /^[0-9]*\d*(\.\d{1,2})?$/,
		NUMERIC_GREATER_THAN_ZERO_TWO_DECIMAL_PLACES:
			/^(0?[.][1-9][0-9]?|0?[.][0-9][1-9]?|0*[1-9][0-9]{0,13}([.][0-9]{1,2})?)$/,
		DATE: /^(0[1-9]|1[0-2])\/(0[1-9]|1[0-9]|2[0-9]|3[0-1])\/\d{4}/, // mm/dd/yyyy
		// tslint:disable-next-line:max-line-length
		URL: /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9]\.[^\s]{2,})/,
		FILE_EXTENSION: /(?:\.([^.]+))?$/,
		COMMA_SEPARATED_NUMBERS: /^\d+(,\d+)*$/,
		URL_SUBDOMAIN: /^[a-zA-Z0-9]+([a-zA-Z0-9-][a-zA-Z0-9]+)*$/, // letters, numbers and "-", ex: "edAssist-test1"
		TEXT_WITHOUT_HTML: /^(?![^]*<[^>]+>)[^]*/,
		TWO_DECIMAL_PERCENTAGE: /^(100(\.0{1,2})?|(\d{1,2})(\.\d{1,2})?)$/,
		httpHeaderFileNameRegex: /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
		NUMERIC_INTEGERS: /^[1-9][0-9]*$/,
		MULTIPLE_EMAIL: /^([a-zA-Z0-9_\-.]+@([a-zA-Z0-9-]+\.)+[a-z]{2,6}(,( ){0,1})*)+$/,
		FIELD_OF_STUDY: /^([a-zA-Z0-9-?–.\/',()&!_:;$]+\s)*([a-zA-Z0-9-?–.\/',()&!_:;$ ]{3,26})+$/,
		EARNINGS_CODE_TOKEN: /^(?! )[a-zA-Z0-9-_() ]+(?<! )$|^#\w+#\w+$/
	},
	ERROR_MESSAGES: {
		APPLICATION_SEARCH: {
			ERROR_NAME: 'applicationNumberNotFound',
			APPLICATION_NOT_FOUND: 'Application Number was not found'
		},
		LINKED_APPLICATION_SEARCH: {
			ERROR_NAME: 'invalidApplicationNumbers',
			INVALID_APPLICATIONS: 'Invalid application(s): '
		},
		DATEPICKER: {
			DATE_FORMAT: 'Please enter a date in MM/DD/YYYY format',
			DATE_RANGE: 'Please select an appropriate date within range'
		},
		SUSPENSION_THRESHOLD: {
			ERROR_NAME: 'suspensionThresholdIsNull',
			SUSPENSION_THRESHOLD_NULL: 'A number value is required when Display Documentation Deadline is enabled'
		}
	},
	INPUT_OPTIONS: {
		ALL: 'All'
	},
	MODAL: {
		BASE_MODAL_CLASS: 'modal',
		BODY_MODAL_OPEN_CLASS: 'modal-open'
	},
	MULTI_SELECT: {
		MULTI_SELECT_DROPDOWN_BASE_ID: 'inputMultiSelect'
	},
	TYPEAHEAD_DROPDOWN: {
		BASE_ID: 'inputTypeaheadDropdownSelect'
	},
	KEYBOARD_CODES: {
		ESCAPE_KEY: 'Escape',
		ENTER_KEY: 'Enter',
		TAB_KEY: 'Tab',
		ARROW_LEFT: 'ArrowLeft',
		ARROW_UP: 'ArrowUp',
		ARROW_RIGHT: 'ArrowRight',
		ARROW_DOWN: 'ArrowDown'
	},
	INPUT_DROPDOWN: {
		DEFAULT_SELECT_DISPLAY: 'Select',
		DEFAULT_SELECT_SKILLS: 'Search Skills',
		DEFAULT_SELECT_JOBS: 'Select Job(s)'
	},
	CERTIFICATION_TYPES: {
		EXAM: 1,
		PREP_COURSE: 2,
		COURSE: 3
	},
	EXPENSE_TABLE: {
		MAX_LENGTH_TUITION_EXPENSE_INPUT: 13,
		MAX_LENGTH_FEE_INPUT: 8,
		FORM_INPUT_SEPARATOR: '_'
	}
};
